import React from 'react';
import BaseSizeSensitiveComponent from './../components/BaseSizeSensitiveComponent';
import ProjectHistoryList from "../ProjectHistory/ProjectHistoryList";


class ServerCloudPlatform extends BaseSizeSensitiveComponent {

    render() {

        var viewWidth = this.state.viewport.width;
        this.styler.setWidth(viewWidth);
        var filters = { industries: [], andTechs: false, techs: ['','',''], andSearch: false, search: ['server','cloud'],};

        return (

            <div style={this.styler.currStyles.Container}>
                <div style={this.styler.currStyles.Header}>
                    <p style={this.styler.currStyles.Header.Title}>Server and Cloud Development Capabilities</p>
                </div>
                <div style={this.styler.currStyles.Body}>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>I have many years of server-side experience. I have developed server-side code in C#, C/C++, Java, Python and Javascript/Node.js using a variety of database technologies. Some of those were in support of mobile apps by serving RESTful APIs for mobile consumption. Those server apps have been hosted on-site, on Azure, Amazon Web Services and other cloud providers.</p>
                    </div>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                    </div>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.title}>Here are some of my recent Server/Cloud projects:</p>
                        <ProjectHistoryList filters={filters} displaycount={false}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default ServerCloudPlatform



// WEBPACK FOOTER //
// src/Platforms/ServerCloudPlatform.js